import React, { useContext, useState } from "react";
import { provideImageOrdersExcludedCurrentFormat, providePriceForFormat, provideValue, } from "../../../../../../sharedScripts/priceProviderInterpreter.js";
import Button from "../../../../../shared/ui/inputs/classicButton.js";
import "./imageOrder.css";
import ProcessingAnimation from "../../../../../../../merchant/panel/scripts/shared/ProcessingAnimation/ProcessingAnimation.js";
import { groupContext } from "../index.js";
import Zoom from "../zoom/zoom.js";
import { usePreviewUrl } from "../../scripts/usePreviewUrl.js";
export default function ImageOrder(props) {
    var _a, _b;
    const { orderData, isReadonly } = props;
    const { electronicFile } = orderData;
    const [zoomOpened, setZoomOpened] = useState(false);
    const group = useContext(groupContext);
    const offerData = group.categories
        .find((c) => c.name === orderData.categoryName)
        .offers.find((o) => o.name === orderData.orderType);
    function updateOrder(format, count) {
        props.onOrderUpdate(format, count);
    }
    const displayImages = group.type !== "form";
    const preview = usePreviewUrl((_a = group === null || group === void 0 ? void 0 : group.appearance) === null || _a === void 0 ? void 0 : _a.imageLoader, orderData.imageName, group.galleryName, group._id);
    return (React.createElement("li", { className: "image-order-list-part" },
        props.isLoading && React.createElement(ProcessingAnimation, null),
        React.createElement("div", { className: "image-info" },
            React.createElement("div", null, orderData.imageName.replace(/\.jpg$/, "")),
            displayImages && (React.createElement("img", { src: preview, height: "66", onSelect: (e) => e.preventDefault(), onContextMenu: (e) => e.preventDefault(), onDragStart: (e) => e.preventDefault(), onClick: () => setZoomOpened(true), className: "image-order-img-preview" })),
            zoomOpened && (React.createElement(Zoom, { onClosed: () => setZoomOpened(false), imageName: orderData.imageName, withoutOrderButtons: true }))),
        React.createElement("div", { className: "image-count-selector" },
            orderData.orderedFormats.map((format, index) => {
                var _a, _b, _c;
                const formatData = offerData.formats[index];
                return (React.createElement("div", { key: index, className: "image-format-container" },
                    React.createElement("span", null,
                        formatData.overridePrefix !== undefined &&
                            formatData.overridePrefix + " ",
                        formatData.type !== "electronic-file" ?
                            formatData.overridePrefix === undefined ?
                                "Format "
                                : ""
                            : "",
                        " ", (_a = formatData["@labelName"]) !== null && _a !== void 0 ? _a : format.name,
                        ":"),
                    React.createElement("div", { className: "image-format-change-buttons-container" },
                        React.createElement("div", { className: "formats-update-buttons" },
                            isReadonly !== true && (React.createElement(Button, { value: "dec", text: "-", classNames: "change-count-button" +
                                    (((_b = formatData.minCount) !== null && _b !== void 0 ? _b : 0) >= format.count ?
                                        " button-disabled"
                                        : ""), onClick: () => updateOrder(format.name, format.count - 1) })),
                            React.createElement("b", null, format.count),
                            isReadonly !== true && (React.createElement(Button, { value: "inc", text: "+", classNames: "change-count-button" +
                                    (((_c = formatData.maxCount) !== null && _c !== void 0 ? _c : Infinity) <= format.count ?
                                        " button-disabled"
                                        : ""), onClick: () => updateOrder(format.name, format.count + 1) })),
                            "szt"),
                        "(",
                        providePriceForFormat(format.pricePerItem, {
                            currentFormatName: format.name,
                            orderedFormats: orderData.orderedFormats,
                            quantity: format.count,
                            imageOrdersExcludedCurrentFormat: provideImageOrdersExcludedCurrentFormat(props.imageOrders.map((order) => ({
                                ...order,
                                orderedFormats: order.orderedFormats.filter((_, i) => i !== index),
                            })), orderData.imageIndex, orderData.offerIndex, format.name),
                        }),
                        " ",
                        "z\u0142)")));
            }),
            (electronicFile === null || electronicFile === void 0 ? void 0 : electronicFile.enabled) &&
                electronicFile.conditions.every((condition) => condition.type === "always_true" ||
                    (condition.type === "when_all_formats_sum_is_more_then" &&
                        orderData.orderedFormats.reduce((acc, format) => acc + format.count, 0) > condition.moreThen)) &&
                isReadonly === false && (React.createElement("div", { className: "image-format-container" },
                "Wersja elektroniczna:",
                " ",
                orderData.orderedElectronicFile === true ? "Tak" : "Nie",
                React.createElement(Button, { value: "inc", text: orderData.orderedElectronicFile ? "-" : "+", classNames: "change-count-button", onClick: () => props.onElectronicFileUpdate(!orderData.orderedElectronicFile) }),
                "(",
                orderData.orderedElectronicFile ?
                    provideValue(orderData.electronicFile.price, {
                        ...orderData,
                        quantity: orderData.orderedElectronicFile ? 1 : 0,
                        imageOrdersExcludedCurrentFormat: props.imageOrders.map((i) => ({ formats: i.orderedFormats })),
                    })
                    : 0,
                " ",
                "z\u0142)"))),
        React.createElement("div", null,
            "Typ: ", (_b = orderData.label) !== null && _b !== void 0 ? _b : orderData.orderType),
        React.createElement("div", null, isReadonly === false && (React.createElement(Button, { value: "remove_image", text: "", version: "alternative", classNames: "remove-image-button", onClick: props.onImageDelete },
            React.createElement("img", { src: "../../assets/icons/delete.svg", width: "24" }))))));
}
